import { Directive, HostListener, input, OnDestroy, output } from '@angular/core';

@Directive({
  selector: '[msDebounceClick]'
})
export class DebounceClickDirective implements OnDestroy {
  public msDebounceTime = input<number>(3000);
  public msDebounceClick = output<MouseEvent>();

  private timeout: ReturnType<typeof setTimeout> | null = null;

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.timeout) return;

    this.msDebounceClick.emit(event);

    this.timeout = setTimeout(() => {
      this.timeout = null;
    }, this.msDebounceTime());
  }

  ngOnDestroy(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
